<div class="modal-header">
  <h4 class="modal-title">Eagle Office</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.close()"
  ></button>
</div>
<div class="modal-body">
  <div class="card bg-light mb-4">
    <div class="card-body">
      <app-branch-info></app-branch-info>
    </div>
  </div>
</div>
